enum ConfigurationAttributes {
  WORK_QUEUE_TABLE_CONFIGURATION = "work_queue_table_configuration",
  WORK_QUEUE_TREE_TABLE_CONFIGURATION = "work_queue_tree_table_configuration",
  PRODUCTION_HISTORY_TABLE_CONFIGURATION = "production_history_table_configuration",
  UTIL_HISTORY_TABLE_CONFIGURATION = "util_history_table_configuration",
  PRODUCTION_LAYOUT_CONFIGURATION = "production_layout_configuration",
  OVERVIEW_LAYOUT_CONFIGURATION = "overview_layout_configuration",
}
export default ConfigurationAttributes;
